// extracted by mini-css-extract-plugin
export default {"root":"styles_root__tmt5W","transparent":"styles_transparent__-shid"};